// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2vn4x","rootCenter":"LoadMoreObserver_rootCenter__1ym49","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2tsej"};